import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import AuthApi from '../../Services/Authapi';
import TableComponent from '../../Layouts/TableComponent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import swal from 'sweetalert';
import TextField from "@material-ui/core/TextField";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import UserDetails from './UserDetails';
import ProfileCompletionCircle from '../../Layouts/ProfileCompletionCircle';
import defaultAvatar from '../../../Images/person.jpg';
import Typography from '@material-ui/core/Typography';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import '../Leaves/Leave.css';

const styles = (theme) => ({
  root: {},
  searchField: {
    marginTop: "0px"
  },
  suggestionContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  paper: {
    position: 'absolute',
    top: '100%',
    right: '0',
    zIndex: 10,
    width: "210px",
    maxHeight: '200px',
    overflowY: 'auto',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    backgroundColor: theme.palette.background.paper
  },
});

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      count: 0,
      isLoading: true,
      searchQuery: "",
      pageStatus: false,
      suggestions: [],
      filterEvents: [],
      tableTh: [
        { id: 'name', numeric: false, disablePadding: true, label: 'Employee ID', sortable: true },
        { id: 'photo', numeric: false, disablePadding: true, label: 'Profile Photo', sortable: true },
        { id: 'firstName', numeric: false, disablePadding: true, label: 'Name', sortable: true },
        { id: 'email', numeric: false, disablePadding: true, label: 'Email', sortable: true },
        { id: 'created_at', numeric: false, disablePadding: true, label: 'Created On', sortable: true },
        { id: 'profileCompletion', numeric: false, disablePadding: true, label: 'Profile Completion', sortable: false },
        { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
      ],
      statusFilter: 'Active',
    };
  }

  componentDidMount() {
    if (this.props && this.props.authToken === false) {
      // Uncomment if you want to redirect to login
      // this.props.history.push('/login');
    }
    this.userData().then(() => {
      this.handleSearch();
    });
  }

  // Field name mapping for display
  getFieldDisplayName = (fieldName) => {
    const fieldMappings = {
      "firstName": "First Name",
      "lastName": "Last Name",
      "photo": "Profile Photo",
      "dob": "Date of Birth",
      "doj": "Date of Joining",
      "bankName": "Bank Name",
      "bankAccNo": "Bank Account Number",
      "designation": "",
      "email": "Email",
      "personal_email": "Personal Email",
      "mobileNo": "Mobile Number",
      "last_organization": "Last Organization",
      "location": "Location",
      "qualification": "Qualification"
    };
    return fieldMappings[fieldName] || fieldName;
  }

  calculateProfileCompletion = (user) => {
    const fields = [
      "firstName",
      "lastName",
      "photo",
      "dob",
      "doj",
      "bankName",
      "bankAccNo",
      "designation",
      "email",
      "personal_email",
      "mobileNo",
      "last_organization",
      "location",
      "qualification"
    ];
    const filled = fields.filter(field => {
      if (field === 'photo') {
        return user[field] && user[field].toString().trim() !== "" && user[field] !== defaultAvatar;
      }
      return user[field] && user[field].toString().trim() !== "";
    }).length;
    return Math.round((filled / fields.length) * 100);
  }

  userData = async () => {
    this.setState({ isLoading: true });
    try {
      let users = await AuthApi.getData();
      if (users && users.status === true) {
        const profileFields = [
          "firstName", "lastName", "photo", "dob", "doj", "bankName", "bankAccNo",
          "designation", "email", "personal_email", "mobileNo", "last_organization",
          "location", "qualification"
        ];
        const usersWithCompletion = users.data.map(user => {
          const safePhoto = user.photo && String(user.photo).trim() !== "" ? user.photo : defaultAvatar;
          const normalizedUser = { ...user, photo: safePhoto };
          return ({
            ...normalizedUser,
            profileCompletion: (
              <ProfileCompletionCircle
                percentage={this.calculateProfileCompletion(normalizedUser)}
                user={normalizedUser}
                fields={profileFields}
                getFieldDisplayName={this.getFieldDisplayName}
                showPercentage={true}
              />
            )
          });
        });
        this.setState({
          users: usersWithCompletion,
          count: usersWithCompletion.length,
          isLoading: false
        }, () => {
          this.handleSearch();
        });
      } else {
        this.setState({
          users: [],
          count: 0,
          filterEvents: [],
          isLoading: false
        });
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      this.setState({
        users: [],
        count: 0,
        filterEvents: [],
        isLoading: false
      });
    }
  }

  removeUser = async (id) => {
    const confirm = await swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    });
    if (confirm) {
      swal({
        title: "Loading",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: createSwalLoaderNode(),
      });
      try {
        let currentUser = await AuthApi.userDelete(id);
        swal.close();
        if (currentUser && currentUser.status === true) {
          this.userData();
          swal("User deleted successfully!", { icon: "success" });
        }
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  }

  statusRow = async (id, status) => {
    const confirm = await swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    });
    if (confirm) {
      swal({
        title: "Loading",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: createSwalLoaderNode(),
      });
      try {
        let statu = await AuthApi.UserStatus(id, status);
        swal.close();
        if (statu && statu.status === true) {
          this.userData();
        }
      } catch (error) {
        console.error('Error updating user status:', error);
      }
    }
  }

  handleChange = (e) => {
    const searchQuery = e.target.value;
    let suggestions = [];
    if (searchQuery.length > 0) {
      suggestions = this.state.users.filter((item) => {
        return (
          (item.email && item.email.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (item.firstName && item.firstName.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      });
    }
    this.setState({ searchQuery, suggestions }, this.handleSearch);
  }

  handleStatusChange = (event) => {
    this.setState({ statusFilter: event.target.value }, this.handleSearch);
  }

  handleSearch = () => {
    const { users, searchQuery, statusFilter } = this.state;
    const profileFields = [
      "firstName", "lastName", "photo", "dob", "doj", "bankName", "bankAccNo",
      "designation", "email", "personal_email", "mobileNo", "last_organization",
      "location", "qualification"
    ];
    const filterEvents = users.filter((item) => {
      const matchesQuery = !searchQuery ||
        (item.email && item.email.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.firstName && item.firstName.toLowerCase().includes(searchQuery.toLowerCase()));
      const matchesStatus = statusFilter === 'All' ||
        (statusFilter === 'Active' && item.user_logged === 1) ||
        (statusFilter === 'Inactive' && item.user_logged === 0);
      return matchesQuery && matchesStatus;
    }).map(user => ({
      ...user,
      profileCompletion: (
        <ProfileCompletionCircle
          percentage={this.calculateProfileCompletion(user)}
          user={user}
          fields={profileFields}
          getFieldDisplayName={this.getFieldDisplayName}
          showPercentage={true}
        />
      )
    }));
    this.setState({ filterEvents });
  }

  clearSearch = () => {
    this.setState({ searchQuery: "", suggestions: [] }, this.handleSearch);
  }

  handleSuggestionClick = (suggestion) => {
    this.setState({ searchQuery: suggestion.firstName, suggestions: [] }, this.handleSearch);
  }

  handleEditClick = (user) => {
    const userId = user.id;
    const randomString = Math.random().toString(36).substring(2, 8);
    const combinedString = `${userId}-${randomString}`;
    const encodedUserId = btoa(combinedString);
    console.log("Encoded User ID:", encodedUserId);
    this.props.history.push(`/users/edit/${encodedUserId}`);
  }

  handleRowClick = (user) => {
    const userId = user.id;
    const randomString = Math.random().toString(36).substring(2, 8);
    const combinedString = `${userId}-${randomString}`;
    const encodedUserId = btoa(combinedString);
    this.props.history.push(`/users/${encodedUserId}`);
  }

  render() {
    const { classes } = this.props;
    const { filterEvents, searchQuery, suggestions, pageStatus, tableTh, statusFilter } = this.state;
    const permissions = (this.props.authUser && Array.isArray(this.props.authUser.userAccess)) ? this.props.authUser.userAccess : [];

    return (
      <Switch>
        <Route exact path="/users">
          <div>
            <AuthCheckComponent authToken={this.props.authToken} />
            <Header
              {...this.props}
              authUser={this.props.authUser}
              setAutUser={this.props.setAutUser}
              component={
                <div>
                  <div className="holiday-breadcrumb-card">
                      <Breadcrumb
                        {...this.props}
                        primaryPageName="Users"
                        primaryPageLink="/users"
                        isSecondaryPage={false}
                        secondaryPageName="" />
                  </div>
                  <TableComponent
                    shellClassName="holiday-table-shell"
                    {...this.props}
                    tableTh={tableTh}
                    tableData={filterEvents}
                    tableCount={filterEvents.length}
                    isLoading={this.state.isLoading}
                    tablePagestatus={pageStatus}
                    order="desc"
                    orderBy="id"
                    colNameToShow={['name', 'photo', 'firstName', 'email', 'created_at', 'profileCompletion']}
                    openPopUp={false}
                    removeRow={this.removeUser}
                    statusRow={this.statusRow}
                    actionBtns={[
                      permissions.includes("Users.Status") && 'status',
                      permissions.includes("Users.Edit") && 'editNew',
                      permissions.includes("Users.Delete") && 'delete'
                    ]}
                    modelName={'User'}
                    addRoute={'/users/add'}
                    updateRoute={'/users/edit'}
                    openPopUpUpdate={false}
                    handleEditClick={this.handleEditClick}
                    onRowClick={this.handleRowClick}
                    extraHeaderContent={
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
                        <TextField
                          className="users-status-filter"
                          select
                          label="Users by Status"
                          value={statusFilter}
                          onChange={this.handleStatusChange}
                          variant="outlined"
                          style={{
                            minWidth: '150px',
                          }}
                          InputProps={{
                            style: {
                              height: '40px'
                            }
                          }}
                          SelectProps={{
                            MenuProps: {
                              PaperProps: {
                                className: "users-status-menu",
                              },
                            },
                          }}
                        >
                          <MenuItem value="All">All</MenuItem>
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </TextField>

                        <div className="holiday-search-wrapper" style={{ marginLeft: "auto" }}>
                          <TextField
                            className="holiday-search-field"
                            label="Search"
                            value={searchQuery}
                            onChange={this.handleChange}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: searchQuery !== "",
                              style: {
                                transition: 'all 0.2s',
                                transform: searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                                pointerEvents: 'none'
                              }
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end" style={{
                                  padding: "0 5px",
                                  minWidth: "40px",
                                  justifyContent: "center",
                                  borderLeft: "1px solid rgba(0, 0, 0, 0.23)",
                                  backgroundColor: "transparent",
                                  height: "100%",
                                  maxHeight: "none",
                                  margin: "0",
                                }}>
                                  {searchQuery && (
                                    <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                                  )}
                                  <SearchIcon onClick={this.handleSearch} style={{ cursor: 'pointer' }} />
                                </InputAdornment>
                              ),
                              style: { paddingRight: 0, height: "40px", padding: 0 }
                            }}
                          />

                          {searchQuery && suggestions.length > 0 && (
                            <Paper className="holiday-search-suggestions">
                              {[...new Set(suggestions.map(suggestion => suggestion.firstName))].map((firstName, index) => (
                                <MenuItem
                                  key={index}
                                  onClick={() => this.handleSuggestionClick({ firstName })}
                                >
                                  {firstName}
                                </MenuItem>
                              ))}
                            </Paper>
                          )}
                        </div>
                      </div>
                    }
                  />
                </div>
              }
            />
            <Footer {...this.props} />
          </div>
        </Route>

        <Route path="/users/:userId" render={({ match }) => {
          const userId = match.params.userId;
          const user = this.state.users.find(user => user.id === parseInt(userId));
          if (user && user.user_logged === 1) {
            return <UserDetails users={this.state.users} authToken={this.props.authToken} authUser={this.props.authUser} {...this.props} />;
          } else {
            swal({
              title: "User Not Active",
              text: "This user is currently not active.",
              icon: "warning",
              button: "OK"
            });
            return <Redirect to="/users" />;
          }
        }} />
      </Switch>
    );
  }
}

export default withStyles(styles)(User);
